import { ServerStatusItem } from '../../types/serverStatusData';

export const serverStatusItems: ServerStatusItem[] = [
  {
    id: 'main',
    serverName: 'Main Server',
  },
];
